import React from 'react';
import { Link } from 'react-router-dom';
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarHeader,
  SubMenu,
} from 'react-pro-sidebar';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  filter, map, some, get,
} from 'lodash';
import sidebarBg from '../../assets/bg1.jpg';
import routes from '../router';
import utils from '../../common/utils';

const Aside = ({
  image, collapsed, rtl, toggled, handleToggleSidebar, handleGetTitle, mapPermissions, session,
}) => {
  const renderSideBarContent = map(routes, (route) => {
    // if (route.children) {
    //   return (
    //     <Menu className="custom-menu" iconShape="circle">
    //       <SubMenu title={route.title} icon={route.icon()}>
    //         {map(route.children, (child) => (
    //           <MenuItem onClick={() => handleGetTitle(child.title)}>
    //             <Link to={child.path}>{child.title}</Link>
    //           </MenuItem>
    //         ))}
    //       </SubMenu>
    //     </Menu>
    //   );
    // }

    // return (
    //   <Menu className="custom-menu" iconShape="circle">
    //     <MenuItem onClick={() => handleGetTitle(route.title)} icon={route.icon()}>
    //       <Link to={route.path}>{route.title}</Link>
    //     </MenuItem>
    //   </Menu>
    // );

    if (route.children) {
      const authRoutes = filter(route.children, (child) => child.isPublic
        || utils.isAdmin(get(session, 'pubkey', ''))
        || some(child.permissions, (path) => !!mapPermissions[path]));
      if (authRoutes.length !== 0) {
        return (
          <Menu className="custom-menu" iconShape="circle">
            <SubMenu title={route.title} icon={route.icon()}>
              {map(authRoutes, (child) => (
                <MenuItem onClick={() => handleGetTitle(child.title)}>
                  <Link to={child.path}>{child.title}</Link>
                </MenuItem>
              ))}
            </SubMenu>
          </Menu>
        );
      }

      return null;
    }

    if (mapPermissions[route.path] || utils.isAdmin(get(session, 'pubkey', ''))) {
      return (
        <Menu className="custom-menu" iconShape="circle">
          <MenuItem onClick={() => handleGetTitle(route.title)} icon={route.icon()}>
            <Link to={route.path}>{route.title}</Link>
          </MenuItem>
        </Menu>
      );
    }

    return null;
  });

  return (
    <ProSidebar
      image={image ? sidebarBg : false}
      rtl={rtl}
      collapsed={collapsed}
      toggled={toggled}
      breakPoint="md"
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader>
        <div
          style={{
            padding: '24px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: 10,
            letterSpacing: '1px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Cryptocurrency Trading Admin
        </div>
      </SidebarHeader>

      <SidebarContent>
        {renderSideBarContent}
      </SidebarContent>

      {/* <SidebarFooter style={{ textAlign: 'center' }}> */}
      {/*  <div */}
      {/*    className="sidebar-btn-wrapper" */}
      {/*    style={{ */}
      {/*      padding: '20px 24px', */}
      {/*    }} */}
      {/*  > */}
      {/*    <a */}
      {/*      href="https://github.com/azouaoui-med/react-pro-sidebar" */}
      {/*      target="_blank" */}
      {/*      className="sidebar-btn" */}
      {/*      rel="noopener noreferrer" */}
      {/*    > */}
      {/*      <FaGithub /> */}
      {/*      <span> viewSource</span> */}
      {/*    </a> */}
      {/*  </div> */}
      {/* </SidebarFooter> */}
    </ProSidebar>
  );
};

Aside.propTypes = {
  collapsed: PropTypes.bool,
  rtl: PropTypes.bool,
  image: PropTypes.bool,
  toggled: PropTypes.bool,
  handleToggleSidebar: PropTypes.func,
};

Aside.defaultProps = {
  collapsed: false,
  rtl: false,
  image: true,
  toggled: false,
  handleToggleSidebar: undefined,
};

export default Aside;
